/*
  THEORIC · PDP v3 (teste, 17/10/2026 · rodada 3 em 19/10)
  Comportamentos das secoes sections/theoric-v3-*.liquid:
  galeria (video e 3D), compra (Kaching, preco, botao), kit, avaliacoes,
  "Ver formula completa", "Ler mais" e o motion dos textos.
  Cada parte so roda se a secao existir.
*/
(function () {
  if (window.__theoricV3 || window.__tv3) return;
  window.__theoricV3 = 1;
  window.__tv3 = true;

  function seguro(fn, label) {
    return function () {
      try { return fn.apply(this, arguments); } catch (e) { try { console.warn("[tv3]", label || '', e); } catch (_) {} }
    };
  }

  var semMovimento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var temIO = 'IntersectionObserver' in window;

  /* ---------- dinheiro: centavos inteiros do inicio ao fim ----------
     Fontes e unidades (23/10): Liquid variant.price e /cart.js = centavos;
     pricing() do bloco Kaching = REAIS (209 / 413.82); evento variants-changed
     do mesmo bloco = centavos. Converter so na borda, formatar uma vez, e
     nunca ler preco de texto renderizado. */
  var FMT = (function () {
    try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }); } catch (e) { return null; }
  })();
  function centavos(v) { if (v === null || v === undefined || v === '') return null; v = Number(v); return isFinite(v) && v >= 0 ? Math.round(v) : null; }
  function reaisParaCentavos(v) { if (v === null || v === undefined || v === '') return null; v = Number(v); return isFinite(v) && v >= 0 ? Math.round(v * 100) : null; }
  function formatar(c) {
    c = centavos(c);
    if (c === null) return '';
    return FMT ? FMT.format(c / 100) : 'R$ ' + (c / 100).toFixed(2).replace('.', ',');
  }
  function pix(c, pct) { return Math.round(c * (100 - pct) / 100); }   // 20900 -> 19855
  function parcela(c, n) { return Math.round(c / n); }                 // mesma regra da gaveta: 20900/6 -> 3483

  /* ---------- galeria: miniaturas <-> faixa com scroll-snap ----------
     Video: so baixa quando chega perto (preload none + capa), toca mudo
     quando o slide esta na tela e pausa ao sair. O botao de play some
     enquanto toca e volta se a pessoa pausar. Modelo 3D: carrega o
     model-viewer do Shopify so quando o produto tem um. */
  function iniciarGaleria(gal) {
    if (gal.__tv3) return;
    gal.__tv3 = true;
    var track = gal.querySelector('[data-tv3-track]');
    var thumbs = gal.querySelectorAll('[data-tv3-thumb]');
    var slides = gal.querySelectorAll('[data-tv3-slide]');
    if (!track) return;

    function marcar(i) {
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    function preparar(slide) {
      var v = slide && slide.querySelector('video');
      if (v && v.preload !== 'auto') v.preload = 'auto';
      // 3D extra (model-viewer 4): o GLB fica em data-src e so baixa aqui; o
      // loading=lazy dele nao dispara dentro da faixa com rolagem lateral
      var mv = slide && slide.querySelector('model-viewer[data-src]');
      if (mv && !mv.getAttribute('src')) mv.setAttribute('src', mv.getAttribute('data-src'));
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        preparar(slides[i]); // video/3D ja comecam a baixar no clique
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        marcar(i);
      });
      // mouse em cima da miniatura do video/3D: ja comeca a baixar
      t.addEventListener('pointerenter', function () { preparar(slides[i]); }, { passive: true });
    });
    var espera;
    track.addEventListener('scroll', function () {
      clearTimeout(espera);
      espera = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        marcar(i);
        var t = thumbs[i];
        if (t && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
          t.parentElement.scrollTo({ left: t.offsetLeft - 16, behavior: 'smooth' });
        }
      }, 80);
    }, { passive: true });

    /* video */
    slides.forEach(function (slide) {
      var v = slide.querySelector('video');
      if (!v) return;
      v.muted = true;
      v.setAttribute('playsinline', '');
      function estado() { slide.classList.toggle('is-playing', !v.paused); }
      v.addEventListener('play', estado);
      v.addEventListener('pause', estado);
      var b = slide.querySelector('[data-tv3-play]');
      if (b) b.addEventListener('click', function () {
        preparar(slide);
        if (v.paused) { slide.__manual = false; v.play().catch(function () {}); }
        else { slide.__manual = true; v.pause(); }
      });
    });
    if (temIO) {
      // ao lado da tela: baixa; mais da metade na tela: toca; saiu: pausa
      var perto = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) preparar(e.target); });
      }, { root: track, rootMargin: '0px 100% 0px 100%' });
      var visto = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target.querySelector('video');
          if (!v) return;
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            if (!semMovimento && !e.target.__manual) v.play().catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: [0, 0.6] });
      slides.forEach(function (s) {
        if (s.querySelector('video')) { perto.observe(s); visto.observe(s); }
        else if (s.querySelector('model-viewer[data-src]')) perto.observe(s);
      });
    }

    /* modelo 3D */
    var modelos = gal.querySelectorAll('model-viewer:not([data-tv3-extra])'); // o 3D extra usa o model-viewer 4, sem a interface da Shopify
    if (modelos.length && window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: function (erro) {
        if (erro || !Shopify.ModelViewerUI) return;
        modelos.forEach(function (mv) { try { new Shopify.ModelViewerUI(mv); } catch (e) {} });
      } }]);
    }
    gal.querySelectorAll('model-viewer').forEach(function (mv) {
      var slide = mv.closest('[data-tv3-slide]');
      var ui = slide && slide.querySelector('[data-tv3-3d]');
      if (ui) seguro(iniciarEstados3d)(mv, slide, ui);
    });
  }

  /* ---------- 3D com estados: Fechado (1o quadro) e Aberto (ultimo) ----------
     A animacao do GLB fica parada e o tempo dela e conduzido daqui:
     fechado -> pausa -> abre -> pausa -> fecha -> ... Os botoes levam direto a
     um estado e param o ciclo; o de pausa liga/desliga o ciclo. O status diz
     onde o produto esta. Fora da tela o ciclo para. */
  function iniciarEstados3d(mv, slide, ui) {
    if (mv.__tv3estados) return;
    mv.__tv3estados = true;
    var pausaFechado = Number(ui.getAttribute('data-pausa-fechado') || 1.4) * 1000;
    var pausaAberto = Number(ui.getAttribute('data-pausa-aberto') || 2.4) * 1000;
    var statusEl = ui.querySelector('[data-tv3-3d-status]');
    var botoes = ui.querySelectorAll('[data-tv3-3d-ir]');
    var auto = ui.querySelector('[data-tv3-3d-auto]');
    var ROTULO = { fechado: 'Fechado', abrindo: 'Abrindo', aberto: 'Aberto', fechando: 'Fechando' };
    var dur = 0, quadro = 0, espera = 0, ciclo = !semMovimento, visivel = true, alvoAtual = 'fechado';

    function status(s) {
      ui.setAttribute('data-estado', s);
      if (statusEl) statusEl.textContent = ROTULO[s];
      botoes.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-tv3-3d-ir') === s ? 'true' : 'false');
      });
    }
    function marcarAuto() {
      if (!auto) return;
      auto.setAttribute('aria-pressed', ciclo ? 'true' : 'false');
      auto.setAttribute('aria-label', ciclo ? 'Pausar animação' : 'Retomar animação');
    }
    function parar() { cancelAnimationFrame(quadro); clearTimeout(espera); }
    function ir(destino, depois) {
      parar();
      alvoAtual = destino;
      var fim = destino === 'aberto' ? Math.max(0, dur - 0.001) : 0; // dur exato volta ao quadro 0 no loop do model-viewer
      var ini = mv.currentTime;
      var falta = Math.abs(fim - ini);
      if (semMovimento || falta < 0.01) {
        mv.currentTime = fim; status(destino);
        if (depois) depois();
        return;
      }
      status(destino === 'aberto' ? 'abrindo' : 'fechando');
      var t0 = null, total = falta * 1000;
      (function passo(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / total);
        mv.currentTime = ini + (fim - ini) * k;
        if (k < 1) { quadro = requestAnimationFrame(passo); return; }
        status(destino);
        if (depois) depois();
      })(performance.now());
    }
    function rodar() {
      if (!ciclo || !visivel || !dur) return;
      parar(); // carga e visibilidade podem chamar ao mesmo tempo: um ciclo so
      var proximo = alvoAtual === 'fechado' ? 'aberto' : 'fechado';
      espera = setTimeout(function () {
        ir(proximo, rodar);
      }, alvoAtual === 'fechado' ? pausaFechado : pausaAberto);
    }
    function pronto() {
      if (!mv.availableAnimations || !mv.availableAnimations.length) { ui.hidden = true; return; }
      // sem autoplay o model-viewer nao escolhe animacao e duration fica 0:
      // escolhe a primeira, toca um instante para ela entrar e pausa no quadro 0
      if (!mv.animationName) mv.animationName = mv.availableAnimations[0];
      mv.play();
      var tentativas = 0;
      (function esperar() {
        if (!mv.duration && tentativas++ < 50) {
          if (tentativas % 10 === 0) mv.play(); // insiste: o 1o play as vezes chega antes da animacao
          setTimeout(esperar, 100);
          return;
        }
        mv.pause();
        dur = mv.duration || 0;
        mv.currentTime = 0;
        status('fechado');
        marcarAuto();
        ui.hidden = !dur;
        rodar();
      })();
    }
    botoes.forEach(function (b) {
      b.addEventListener('click', function () {
        ciclo = false; marcarAuto();
        ir(b.getAttribute('data-tv3-3d-ir'));
      });
    });
    if (auto) auto.addEventListener('click', function () {
      ciclo = !ciclo; marcarAuto();
      if (ciclo) rodar(); else parar();
    });
    if (temIO) {
      new IntersectionObserver(function (es) {
        visivel = es[0].isIntersecting;
        parar();
        if (!visivel) { mv.currentTime = alvoAtual === 'aberto' ? Math.max(0, dur - 0.001) : 0; status(alvoAtual); }
        else rodar();
      }, { threshold: 0.5 }).observe(slide);
    }
    if (mv.loaded) pronto(); else mv.addEventListener('load', pronto, { once: true });
  }

  /* ---------- carrinho: um ponto so "adicionou -> atualiza -> abre" ----------
     Com o Kaching Cart (a gaveta visivel), abre so depois do refreshCart(),
     para nunca mostrar o carrinho de antes da adicao; a gaveta do tema
     (cart-theoric, escondida atras) nao abre. Sem Kaching, fluxo antigo. */
  function gaveta() {
    return document.getElementById('TheoricCartDrawer') || document.querySelector('cart-theoric');
  }
  function avisarCarrinho(resposta) {
    var g = gaveta();
    if (g && typeof g.renderContents === 'function' && resposta && resposta.sections) {
      try { g.renderContents(resposta); } catch (e) {}
    } else if (window.TheoricCart) {
      try { if (TheoricCart.sincronizar) TheoricCart.sincronizar(true); } catch (e) {}
      try { if (TheoricCart.atualizarBolinha) TheoricCart.atualizarBolinha(); } catch (e) {}
    }
    setTimeout(function () {
      var g2 = gaveta();
      if (g2 && typeof g2.open === 'function') { try { g2.open(); } catch (e) {} }
    }, 60);
  }
  var timerDepois = null;
  function abrirKaching(api) {
    var aberto = false;
    function abrir() {
      if (aberto) return;
      aberto = true;
      try { api.openCart(); } catch (e) { console.warn('[tv3] openCart', e); }
    }
    // refreshCart demorou mais de 2,5 s: abre assim mesmo e pede outro refresh
    var limite = setTimeout(function () {
      abrir();
      try { api.refreshCart(); } catch (e) {}
    }, 2500);
    var p;
    try { p = api.refreshCart(); } catch (e) { p = null; }
    Promise.resolve(p).then(function () { clearTimeout(limite); abrir(); }, function () { clearTimeout(limite); abrir(); });
  }
  function depoisDeAdicionar(respostaAdd) {
    var api = window.kachingCartApi;
    if (!api || typeof api.refreshCart !== 'function' || typeof api.openCart !== 'function') {
      avisarCarrinho(respostaAdd);
      return;
    }
    // o caminho do kit e o do pubsub podem chegar juntos: um refresh so
    clearTimeout(timerDepois);
    timerDepois = setTimeout(function () {
      abrirKaching(api);
      // bolinha do cabecalho e estado do tema continuam em dia, sem abrir cart-theoric
      if (window.TheoricCart) {
        try { if (TheoricCart.sincronizar) TheoricCart.sincronizar(true); } catch (e) {}
      }
    }, 100);
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, seguro(function (ev) {
      if (!ev || ev.source !== 'product-form' || !document.querySelector('.tv3-hero')) return;
      if (window.kachingCartApi) depoisDeAdicionar(ev.cartData);
    }, 'depois-de-adicionar'));
  }

  document.addEventListener('click', seguro(function (ev) {
    var btn = ev.target.closest('[data-tv3-kit-add]');
    if (!btn || btn.disabled) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var rotulo = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adicionando...';
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: 'cart-theoric,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart/add ' + r.status); return r.json(); })
      .then(function (json) { depoisDeAdicionar(json); btn.textContent = rotulo; })
      .catch(function () { btn.textContent = 'Tente de novo'; })
      .finally(function () { btn.disabled = false; });
  }, 'kit-add'));

  /* ---------- avaliacoes ---------- */
  // monta o widget do Judge.me (guardado num <template>) uma unica vez
  function montarJudgeme(painel) {
    var tpl = painel && painel.querySelector('template[data-tv3-av-tpl]');
    if (!tpl) return;
    var conteudo = document.importNode(tpl.content, true);
    function semProduto(dado) {
      if (Array.isArray(dado)) return dado.map(semProduto).filter(function (item) { return item !== undefined; });
      if (!dado || typeof dado !== 'object') return dado;
      var tipos = dado['@type'];
      if (tipos === 'Product' || (Array.isArray(tipos) && tipos.indexOf('Product') !== -1)) return undefined;
      var limpo = {};
      Object.keys(dado).forEach(function (chave) {
        var valor = semProduto(dado[chave]);
        if (valor !== undefined) limpo[chave] = valor;
      });
      return limpo;
    }
    conteudo.querySelectorAll('script[type="application/ld+json"]').forEach(function (script) {
      try {
        var dado = semProduto(JSON.parse(script.textContent));
        if (!dado || (Array.isArray(dado) && !dado.length) || (dado['@graph'] && !dado['@graph'].length)) script.remove();
        else script.textContent = JSON.stringify(dado);
      } catch (e) { script.remove(); }
    });
    painel.appendChild(conteudo);
    tpl.remove();
  }
  function judgemeAoAproximar(sec) {
    var painel = sec.querySelector('[data-tv3-av-todas]');
    if (!painel || !temIO || sec.__tv3jm) return;
    sec.__tv3jm = true;
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      montarJudgeme(painel);
    }, { rootMargin: '600px 0px' });
    io.observe(sec);
  }
  document.addEventListener('click', seguro(function (ev) {
    var b = ev.target.closest('[data-tv3-av]');
    if (!b) return;
    var sec = b.closest('.tv3-av');
    var painel = sec && sec.querySelector('[data-tv3-av-todas]');
    if (!painel) return;
    ev.preventDefault();
    painel.hidden = false;
    montarJudgeme(painel);
    if (b.getAttribute('data-tv3-av') === 'escrever') {
      var achar = function () { return painel.querySelector('.jm-action-buttons__button.jm-button--primary, .jdgm-write-rev-link, [class*="write-rev"]'); };
      var link = achar();
      if (link) link.click();
      else if (window.MutationObserver) {
        // o widget acabou de entrar: espera o botao aparecer (ate 6 s)
        var mo = new MutationObserver(function () {
          var l = achar();
          if (l) { mo.disconnect(); l.click(); }
        });
        mo.observe(painel, { childList: true, subtree: true });
        setTimeout(function () { mo.disconnect(); }, 6000);
      }
    }
    painel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 'avaliacoes'));

  // setas da faixa de comentarios
  function iniciarFaixa(sec) {
    var faixa = sec.querySelector('[data-tv3-faixa]');
    if (!faixa || faixa.__tv3) return;
    faixa.__tv3 = true;
    var ant = sec.querySelector('[data-tv3-faixa-ant]');
    var prox = sec.querySelector('[data-tv3-faixa-prox]');
    function passo() {
      var c = faixa.firstElementChild;
      return c ? c.getBoundingClientRect().width + 16 : faixa.clientWidth * 0.8;
    }
    function setas() {
      if (ant) ant.disabled = faixa.scrollLeft < 4;
      if (prox) prox.disabled = faixa.scrollLeft + faixa.clientWidth >= faixa.scrollWidth - 4;
    }
    if (ant) ant.addEventListener('click', function () { faixa.scrollBy({ left: -passo(), behavior: 'smooth' }); });
    if (prox) prox.addEventListener('click', function () { faixa.scrollBy({ left: passo(), behavior: 'smooth' }); });
    faixa.addEventListener('scroll', function () { clearTimeout(faixa.__t); faixa.__t = setTimeout(setas, 60); }, { passive: true });
    setas();
  }

  // galeria de fotos/videos das clientes: abre num dialogo grande
  document.addEventListener('click', seguro(function (ev) {
    var item = ev.target.closest('[data-tv3-foto]');
    if (!item) return;
    var d = document.getElementById(item.getAttribute('data-tv3-foto'));
    if (!d || !d.showModal) return;
    ev.preventDefault();
    var palco = d.querySelector('[data-tv3-palco]');
    var leg = d.querySelector('[data-tv3-legenda]');
    var src = item.getAttribute('data-src');
    palco.innerHTML = '';
    var midia;
    if (item.getAttribute('data-tipo') === 'video') {
      midia = document.createElement('video');
      midia.controls = true; midia.autoplay = true; midia.playsInline = true;
      if (item.getAttribute('data-capa')) midia.poster = item.getAttribute('data-capa');
    } else {
      midia = document.createElement('img');
      midia.alt = '';
    }
    midia.src = src;
    palco.appendChild(midia);
    if (leg) leg.textContent = item.getAttribute('data-legenda') || '';
    d.showModal();
  }, 'foto'));

  /* ---------- dialogos ("Ver formula completa", galeria) ---------- */
  document.addEventListener('click', seguro(function (ev) {
    var abrir = ev.target.closest('[data-tv3-dialog]');
    if (abrir) {
      var d = document.getElementById(abrir.getAttribute('data-tv3-dialog'));
      if (d && d.showModal) { ev.preventDefault(); d.showModal(); }
      return;
    }
    var fechar = ev.target.closest('[data-tv3-fechar]');
    if (fechar) { var dd = fechar.closest('dialog'); if (dd) dd.close(); return; }
    if (ev.target.tagName === 'DIALOG' && ev.target.classList.contains('tv3-dialog')) ev.target.close();
  }, 'dialogo'));
  // fechou a galeria: para o video
  document.addEventListener('close', seguro(function (ev) {
    var palco = ev.target && ev.target.querySelector && ev.target.querySelector('[data-tv3-palco]');
    if (palco) palco.innerHTML = '';
  }, 'fechar-galeria'), true);

  /* ---------- "Ler mais" da descricao ---------- */
  document.addEventListener('click', seguro(function (ev) {
    var b = ev.target.closest('[data-tv3-mais]');
    if (!b) return;
    var alvo = document.getElementById(b.getAttribute('aria-controls'));
    if (!alvo) return;
    var aberto = b.getAttribute('aria-expanded') === 'true';
    alvo.classList.toggle('is-aberto', !aberto);
    b.setAttribute('aria-expanded', aberto ? 'false' : 'true');
    b.textContent = aberto ? (b.getAttribute('data-mais') || 'Ler mais') : (b.getAttribute('data-menos') || 'Ler menos');
  }, 'ler-mais'));

  /* ---------- Abas Beneficios / Caracteristicas ----------
     Clique troca a aba; setas esquerda/direita, Home e End seguem o padrao
     de tablist do WAI-ARIA. */
  function ativarAba(tab, focar) {
    var bar = tab.closest('[role="tablist"]');
    if (!bar) return;
    bar.querySelectorAll('[role="tab"]').forEach(function (t) {
      var sel = t === tab;
      t.setAttribute('aria-selected', sel ? 'true' : 'false');
      t.tabIndex = sel ? 0 : -1;
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !sel;
    });
    if (focar) tab.focus();
  }
  document.addEventListener('click', seguro(function (ev) {
    var tab = ev.target.closest('[data-tv3-abas] [role="tab"]');
    if (tab) ativarAba(tab, false);
  }, 'abas'));
  document.addEventListener('keydown', seguro(function (ev) {
    var tab = ev.target.closest && ev.target.closest('[data-tv3-abas] [role="tab"]');
    if (!tab) return;
    var tabs = Array.prototype.slice.call(tab.parentNode.querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab), n = tabs.length, alvo = null;
    if (ev.key === 'ArrowRight') alvo = tabs[(i + 1) % n];
    else if (ev.key === 'ArrowLeft') alvo = tabs[(i - 1 + n) % n];
    else if (ev.key === 'Home') alvo = tabs[0];
    else if (ev.key === 'End') alvo = tabs[n - 1];
    if (!alvo) return;
    ev.preventDefault();
    ativarAba(alvo, true);
  }, 'abas-teclado'));

  /* ---------- compra: Kaching + preco + botao ----------
     O Kaching aparece como e (desenho em assets/theoric-kaching.css). Ele
     injeta no <form> um input "quantity" e marca a linha escolhida. Daqui:
     1) na primeira vez, marca a oferta padrao (1 unidade);
     2) preco total em centavos: kit = data-preco do Liquid; Kaching =
        pricing() convertido de reais; sem Kaching = data-preco x quantidade;
     3) o tema e o unico escritor de valor, Pix, parcelas e barra fixa (o
        Kaching escreve no [data-kaching-price] oculto, so dele);
     4) o botao diz o que vai para a sacola ("Adicionar 2 unidades"). */
  function trocarTexto(el, novo) {
    if (!el || el.textContent === novo) return;
    el.textContent = novo;
    if (semMovimento) return;
    // INP: sem leitura de layout (offsetWidth) no toque. A animacao reinicia
    // dois quadros depois, e todos os textos trocados juntos entram num lote so.
    el.classList.remove('tv3-troca');
    filaTroca.push(el);
    if (filaTroca.length > 1) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var lote = filaTroca.splice(0);
        for (var i = 0; i < lote.length; i++) lote[i].classList.add('tv3-troca');
      });
    });
  }
  var filaTroca = [];
  function iniciarCompra(hero) {
    var alvo = hero.querySelector('[data-tv3-preco]');
    var caixa = hero.querySelector('[data-tv3-ofertas]');
    if (!alvo || alvo.__tv3) return;
    alvo.__tv3 = true;
    var pixConfig = alvo.getAttribute('data-pix');
    var pixPct = pixConfig === null || pixConfig === '' ? 5 : Number(pixConfig);
    if (!isFinite(pixPct)) pixPct = 5;
    pixPct = Math.max(0, Math.min(100, pixPct));
    var pixLinha = hero.querySelector('[data-tv3-pix]');
    var parcelas = Number(alvo.getAttribute('data-parcelas') || 1);
    if (!isFinite(parcelas) || parcelas < 1) parcelas = 1;
    var base = centavos(alvo.getAttribute('data-preco')) || 0;
    var padrao = Number((caixa && caixa.getAttribute('data-padrao')) || 1);
    // comparar desenhos no preview sem salvar: ?ofertas=linhas | empilhado | cartoes
    try {
      var est = new URLSearchParams(location.search).get('ofertas');
      if (caixa && /^(linhas|empilhado|cartoes)$/.test(est || '')) caixa.setAttribute('data-estilo', est);
    } catch (e) {}
    var valor = alvo.querySelector('.tv3-preco__valor');
    var linha = hero.querySelector('[data-tv3-parcelas]');
    var rotBtn = hero.querySelector('[data-tv3-btn-txt]');
    var btn = hero.querySelector('form.tv3-comprar button[type="submit"]');
    var marcouPadrao = false;
    // ultimo total do evento variants-changed: ja vem em CENTAVOS (nao multiplicar)
    var ultimoTotalCentavosEvento = null;

    function quantidade(n) {
      n = Number(n);
      return isFinite(n) && n > 0 && Math.floor(n) === n ? n : null;
    }
    function qtdDaLinha(bar) {
      return bar ? quantidade(bar.getAttribute('data-quantity')) : null;
    }
    function blocoKaching() {
      return caixa && caixa.querySelector('kaching-bundle kaching-bundles-block');
    }
    /* Total do Kaching em centavos, ou null. Guarda de sanidade contra outra
       troca de unidade no app: o total fica entre 50% e 100% do preco cheio. */
    function totalKaching(qtd) {
      var bloco = blocoKaching();
      var p = null, total = null, cheio = null;
      if (bloco && typeof bloco.pricing === 'function') {
        try { p = bloco.pricing(); } catch (e) { console.warn('[tv3]', e); }
      }
      if (p && p.discountedPrice) total = reaisParaCentavos(p.discountedPrice.amount);
      if (total === null) total = ultimoTotalCentavosEvento;
      if (total === null) return null;
      if (p && p.fullPrice) cheio = reaisParaCentavos(p.fullPrice.amount);
      if (!cheio) cheio = base * qtd;
      if (cheio > 0 && (total < cheio * 0.5 || total > cheio + 1)) {
        console.warn('[tv3] total fora da faixa', total, cheio, qtd);
        return { invalido: true, formatado: p && p.discountedPrice && p.discountedPrice.formatted };
      }
      return total;
    }
    function copiarFixa() {
      var fixa = document.querySelector('[data-tv3-fixa-valor]');
      if (fixa && valor && fixa.textContent !== valor.textContent) fixa.textContent = valor.textContent;
    }
    function mostrarPreco(total) {
      trocarTexto(valor, formatar(total));
      copiarFixa();
      if (pixLinha) {
        pixLinha.hidden = pixPct <= 0;
        trocarTexto(pixLinha, 'ou ' + formatar(pix(total, pixPct)) + ' no Pix');
      }
      if (linha && parcelas > 1) {
        linha.hidden = false;
        trocarTexto(linha, 'em até ' + parcelas + '× de ' + formatar(parcela(total, parcelas)) + ' sem juros');
      }
    }
    function manterPrecoNativo(formatadoApp) {
      // Sem total confiavel: o valor mostra o texto pronto do app (quando ha),
      // e Pix/parcelas somem em vez de sair de um numero duvidoso.
      if (formatadoApp && typeof formatadoApp === 'string') trocarTexto(valor, formatadoApp);
      copiarFixa();
      if (pixLinha) pixLinha.hidden = true;
      if (linha) linha.hidden = true;
    }
    function marcarPadrao() {
      if (marcouPadrao || !caixa) return;
      // O app ja controla a selecao inicial. Nunca trocar uma selecao existente.
      if (caixa.querySelector('.kaching-bundles__bar--selected')) { marcouPadrao = true; return; }
      var bars = caixa.querySelectorAll('.kaching-bundles__bar');
      if (!bars.length) return;
      marcouPadrao = true;
      for (var i = 0; i < bars.length; i++) {
        if (qtdDaLinha(bars[i]) === padrao) {
          if (!bars[i].classList.contains('kaching-bundles__bar--selected')) {
            var c = bars[i].querySelector('label') || bars[i].querySelector('input');
            if (c) c.click();
          }
          break;
        }
      }
    }
    /* Oferta de kit do tema (ex.: Ritual corpo). Escolhida: o "id" do form vira
       o kit e os campos do Kaching (quantity e properties[__kaching_*]) ficam
       desligados, para o kit entrar na sacola pelo preco dele. Clicar numa linha
       do Kaching volta tudo. */
    var kitBtn = hero.querySelector('[data-tv3-kit-op]');
    var modoKit = false;
    var idProduto = null;
    function camposKaching(form) {
      return Array.prototype.filter.call(form.querySelectorAll('input'), function (i) {
        return i.name === 'quantity' || i.name.indexOf('properties[__kaching') === 0;
      });
    }
    function ativarKit(on) {
      if (on && /^(f1|f2)$/.test(document.documentElement.dataset.fase || '')) return;
      var form = hero.querySelector('form.tv3-comprar');
      var idIn = form && form.querySelector('input[name="id"]');
      if (!kitBtn || !idIn) return;
      if (idProduto === null) idProduto = idIn.value;
      modoKit = on;
      kitBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (caixa) caixa.classList.toggle('is-kit', on);
      idIn.value = on ? kitBtn.getAttribute('data-variant-id') : idProduto;
      camposKaching(form).forEach(function (i) {
        if (on) {
          if (typeof i.__tv3disabled === 'undefined') i.__tv3disabled = i.disabled;
          i.disabled = true;
        } else if (typeof i.__tv3disabled !== 'undefined') {
          i.disabled = i.__tv3disabled;
          delete i.__tv3disabled;
        }
      });
      atualizar();
    }
    // O Kaching intercepta o envio do form e monta o pedido pela oferta dele,
    // ignorando o "id" trocado. Com o kit escolhido, a compra e feita aqui,
    // antes de qualquer outro ouvinte (captura na window), pelo mesmo caminho
    // do botao "Adicionar kit" da pagina (/cart/add.js + gaveta).
    function adicionarKit(ev) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      if (!btn || btn.disabled) return;
      var erroBox = hero.querySelector('.product-form__error-message-wrapper');
      var erroTxt = hero.querySelector('.product-form__error-message');
      if (erroBox) erroBox.hidden = true;
      btn.disabled = true;
      btn.classList.add('loading');
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(kitBtn.getAttribute('data-variant-id')), quantity: 1 }],
          sections: 'cart-theoric,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (json) {
          depoisDeAdicionar(json);
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1900);
        })
        .catch(function (e) {
          if (erroTxt) erroTxt.textContent = (e && (e.description || e.message)) || 'Não foi possível adicionar. Tente de novo.';
          if (erroBox) erroBox.hidden = false;
        })
        .finally(function () { btn.disabled = false; btn.classList.remove('loading'); });
    }
    if (kitBtn) {
      window.addEventListener('click', function (e) {
        if (!modoKit) return;
        var b = e.target.closest && e.target.closest('button[type="submit"]');
        if (b && b === btn) adicionarKit(e);
      }, true);
      window.addEventListener('submit', function (e) {
        if (modoKit && hero.contains(e.target)) adicionarKit(e);
      }, true);
      kitBtn.addEventListener('click', function () { ativarKit(true); });
      // qualquer clique nas linhas do Kaching sai do kit (antes do Kaching tratar)
      hero.addEventListener('click', function (e) {
        if (modoKit && e.target.closest('.kaching-bundles')) ativarKit(false);
      }, true);
    }

    function atualizar() {
      marcarPadrao();
      var form = hero.querySelector('form.tv3-comprar');
      if (modoKit && form) {
        camposKaching(form).forEach(function (i) {
          if (typeof i.__tv3disabled === 'undefined') i.__tv3disabled = i.disabled;
          i.disabled = true;
        });
        // data-preco-fase / data-preco: centavos do Liquid (variant.price)
        var totalKit = centavos(kitBtn.getAttribute('data-preco-fase'));
        if (totalKit === null) totalKit = centavos(kitBtn.getAttribute('data-preco'));
        if (totalKit !== null) mostrarPreco(totalKit);
        else manterPrecoNativo();
        if (rotBtn && btn && !btn.disabled) trocarTexto(rotBtn, 'Adicionar ' + kitBtn.getAttribute('data-nome') + ' à sacola');
        return;
      }
      var q = form && form.querySelector('input[name="quantity"]:not(:disabled)');
      var sel = caixa && caixa.querySelector('.kaching-bundles__bar--selected');
      var qtd = quantidade(q && q.value) || qtdDaLinha(sel);
      var bundle = caixa && caixa.querySelector('kaching-bundle, .kaching-bundles');
      var total = null;
      if (qtd && bundle) total = totalKaching(qtd);
      else if (qtd) total = base * qtd;
      if (typeof total === 'number') mostrarPreco(total);
      else manterPrecoNativo(total && total.formatado);
      if (rotBtn && btn && !btn.disabled) {
        trocarTexto(rotBtn, qtd ? 'Adicionar ' + qtd + (qtd === 1 ? ' unidade' : ' unidades') + ' à sacola' : 'Adicionar à sacola');
      }
    }
    atualizar = seguro(atualizar);
    // um debounce so (40 ms) para todos os gatilhos
    function agendar() { clearTimeout(alvo.__t); alvo.__t = setTimeout(atualizar, 40); }
    hero.addEventListener('change', agendar);
    hero.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.kaching-bundles')) agendar(); });
    if (caixa) {
      // eventos do kaching-bundles-block; captura pega o evento mesmo que o bloco seja recriado
      caixa.addEventListener('variants-changed', seguro(function (e) {
        var p = e && e.detail && e.detail.pricing;
        var c = p && p.discountedPrice ? centavos(p.discountedPrice.amount) : null;
        if (c !== null) ultimoTotalCentavosEvento = c;
        agendar();
      }, 'variants-changed'), true);
      caixa.addEventListener('deal-bar-selected', agendar, true);
    }
    if (caixa && window.MutationObserver) {
      // montagem do bloco e troca de linha (classe / data-quantity); o no de
      // preco nao e observado: so este script escreve nele
      new MutationObserver(agendar)
        .observe(caixa, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-quantity'] });
    }
    atualizar();
  }

  /* ---------- barra fixa (mobile) + confirmacao "Adicionado" ---------- */
  function iniciarBotao(hero) {
    var btn = hero.querySelector('form.tv3-comprar button[type="submit"]');
    if (!btn || btn.__tv3) return;
    btn.__tv3 = true;

    // Mesmo criterio do theoric-motion.js: confirma so quando o tema publica
    // cartUpdate (a adicao deu certo), nunca no clique.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      var timer;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (!ev || ev.source !== 'product-form') return;
        btn.classList.add('is-added');
        clearTimeout(timer);
        timer = setTimeout(function () { btn.classList.remove('is-added'); }, 1900);
      });
    }

    var fixa = document.querySelector('[data-tv3-fixa]');
    if (!fixa) return;
    var fbtn = fixa.querySelector('[data-tv3-fixa-btn]');
    if (fbtn) fbtn.addEventListener('click', function () { btn.click(); });
    if (!temIO) return;
    // alvo explicito: um <footer> generico pega o rodape dos cards de avaliacao
    var rodape = document.querySelector('[data-tv3-rodape]') ||
      document.querySelector('footer.tfoot, body > footer, #shopify-section-footer');
    var botaoVisivel = true, rodapeVisivel = false;
    function aplicar() {
      var mostrar = !botaoVisivel && !rodapeVisivel && btn.getBoundingClientRect().top < 0;
      fixa.classList.toggle('is-visible', mostrar);
      fixa.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
      if (fbtn) fbtn.tabIndex = mostrar ? 0 : -1;
    }
    new IntersectionObserver(function (es) { botaoVisivel = es[0].isIntersecting; aplicar(); }).observe(btn);
    if (rodape) new IntersectionObserver(function (es) { rodapeVisivel = es[0].isIntersecting; aplicar(); }).observe(rodape);
  }

  /* ---------- motion dos textos (secoes abaixo do topo) ----------
     Titulos ficam parados (a subida palavra por palavra saiu em 19/10); textos de
     apoio sobem com fade em cascata curta; numeros do resultado contam ate
     o valor. Regra do site: motion nunca e pre-requisito de conteudo. Sem
     JS nada fica escondido, e o estado "escondido" so e aplicado ao que esta
     abaixo da tela no momento em que o script roda. O topo da pagina nao
     anima: aparece pronto. */
  var SEL_TEXTO = [
    '.tv3-anim .tv3-eyebrow', '.tv3-anim .tv3-amar__intro', '.tv3-anim .tv3-amar__pp',
    '.tv3-anim .tv3-amar__item', '.tv3-anim .tv3-frag__txt', '.tv3-anim .tv3-notas tr',
    '.tv3-anim .tv3-res__nota', '.tv3-anim .tv3-res__rot', '.tv3-anim .tv3-av__card',
    '.tv3-anim .tv3-av__fotos', '.tv3-anim .tv3-av__resumo > *', '.tv3-anim .tv3-at__card',
    '.tv3-anim .tv3-at__sub', '.tv3-anim .tv3-desc__corpo', '.tv3-anim .tv3-passos li',
    '.tv3-anim .tv3-kit__card', '.tv3-anim .tv3-faq details'
  ].join(',');

  function contar(el) {
    if (el.__tv3conta) return;
    el.__tv3conta = true;
    var txt = el.textContent;
    var m = txt.match(/(\d+(?:[.,]\d+)?)/);
    if (!m) return;
    var virgula = m[1].indexOf(',') > -1;
    var fim = parseFloat(m[1].replace(',', '.'));
    var casas = (m[1].split(/[.,]/)[1] || '').length;
    var t0 = null, dur = 1200;
    function quadro(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - k, 4);
      var n = (fim * e).toFixed(casas);
      if (virgula) n = n.replace('.', ',');
      el.textContent = k < 1 ? txt.replace(m[1], n) : txt;
      if (k < 1) requestAnimationFrame(quadro);
    }
    requestAnimationFrame(quadro);
  }

  function iniciarMotion() {
    if (semMovimento || !temIO) return;
    var alturaTela = window.innerHeight || 800;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        if (e.target.classList.contains('tv3-res__num')) contar(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    function abaixoDaTela(el) { return el.getBoundingClientRect().top > alturaTela * 0.92; }

    document.querySelectorAll(SEL_TEXTO).forEach(function (el) {
      if (el.__tv3m || !abaixoDaTela(el)) return;
      el.__tv3m = true;
      el.classList.add('tv3-rev');
      var pai = el.parentElement;
      var idx = pai ? Array.prototype.indexOf.call(pai.children, el) % 6 : 0;
      el.style.setProperty('--d', (idx * 70) + 'ms');
      io.observe(el);
    });
    document.querySelectorAll('.tv3-anim .tv3-res__num').forEach(function (el) {
      if (el.__tv3m || !abaixoDaTela(el)) return;
      el.__tv3m = true;
      io.observe(el);
    });
  }

  function iniciar() {
    document.querySelectorAll('[data-tv3-gal]').forEach(seguro(iniciarGaleria));
    document.querySelectorAll('.tv3-hero').forEach(seguro(iniciarBotao));
    document.querySelectorAll('.tv3-hero').forEach(seguro(iniciarCompra));
    document.querySelectorAll('.tv3-av').forEach(seguro(iniciarFaixa));
    document.querySelectorAll('.tv3-av').forEach(seguro(judgemeAoAproximar));
    seguro(iniciarMotion)();
  }
  var iniciarSeguro = seguro(iniciar, 'iniciar');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarSeguro);
  else iniciarSeguro();
  document.addEventListener('shopify:section:load', iniciarSeguro);
})();
